/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { DocumentsTypes, DocumentsState } from './types';

const INITIAL_STATE: DocumentsState = {
  documents: [],
  documents_list: {
    message: '',
    message_view: false,
    class_success_or_failure: '',
    company_name: '',
    monitored_company: '',
    monitored_companies: [],
    current_cnpj: '',
    company: [],
  },
  request: {
    get_documents: {
      loading: false,
      loaded: false,
      error: false,
    },
    filter_documents: {
      loading: false,
      loaded: false,
      error: false,
    },
    service_subscription_status: {
      loading: false,
      loaded: false,
      error: false,
    },
    delete_document: {
      loading: false,
      loaded: false,
      error: false,
    },
    save_doc_database: {
      loading: false,
      loaded: false,
      error: false,
    },
    update_document: {
      loading: false,
      loaded: false,
      error: false,
    },
    authenticate_document: {
      loading: false,
      loaded: false,
      error: false,
    },
    download_authenticated_document: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<DocumentsState> = (
  state = INITIAL_STATE,
  { type, result, docs, document, documentId, currentCompany, company },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case DocumentsTypes.GET_DOCUMENTS_REQUEST:
        draft.request.get_documents = { loading: true, loaded: false, error: false };
        break;
      case DocumentsTypes.GET_DOCUMENTS_SUCCESS:
        draft.documents = result.data.documents;
        draft.documents_list.company_name = result?.data?.monitored_company?.company_name;
        draft.documents_list.monitored_company = result?.data?.monitored_company?.monitored_company;
        draft.documents_list.monitored_companies = result?.data?.monitored_companies;
        draft.request.get_documents = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case DocumentsTypes.GET_DOCUMENTS_FAILURE:
        draft.documents = INITIAL_STATE.documents;
        draft.documents_list.company_name = INITIAL_STATE.documents_list.company_name;
        draft.documents_list.monitored_company = INITIAL_STATE.documents_list.monitored_company;
        draft.request.get_documents = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_REQUEST:
        draft.request.service_subscription_status = { loading: true, loaded: false, error: false };
        break;

      case DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_SUCCESS:
        draft.request.service_subscription_status = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_FAILURE:
        draft.documents = INITIAL_STATE.documents;
        draft.request.service_subscription_status = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case DocumentsTypes.DELETE_DOCUMENT_REQUEST:
        draft.documents_list.message = '';
        draft.request.delete_document = { loading: true, loaded: false, error: false };
        break;

      case DocumentsTypes.DELETE_DOCUMENT_SUCCESS:
        draft.request.delete_document = {
          loading: false,
          loaded: true,
          error: false,
        };
        draft.documents = state.documents.filter((document) => document.id !== documentId);
        break;

      case DocumentsTypes.DELETE_DOCUMENT_FAILURE:
        draft.documents = INITIAL_STATE.documents;
        draft.request.delete_document = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case DocumentsTypes.SAVE_DOC_DATABASE_REQUEST:
        draft.documents_list.message = '';
        draft.request.save_doc_database = { loading: true, loaded: false, error: false };
        break;

      case DocumentsTypes.SAVE_DOC_DATABASE_SUCCESS:
        draft.documents_list.message = result?.data?.message;
        draft.documents_list.message_view = true;
        draft.documents_list.class_success_or_failure = 'alert-success';
        draft.request.save_doc_database = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case DocumentsTypes.SAVE_DOC_DATABASE_FAILURE:
        draft.documents_list.message = 'Não foi possível incluir o documento';
        draft.documents_list.message_view = true;
        draft.documents_list.class_success_or_failure = 'alert-danger';
        draft.request.save_doc_database = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case DocumentsTypes.FILTER_DOCUMENTS_REQUEST:
        draft.request.filter_documents = { loading: true, loaded: false, error: false };
        break;

      case DocumentsTypes.FILTER_DOCUMENTS_SUCCESS:
        draft.documents = result?.data?.documents;
        draft.request.filter_documents = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case DocumentsTypes.FILTER_DOCUMENTS_FAILURE:
        draft.request.filter_documents = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case DocumentsTypes.ALERT_TIME:
        draft.documents_list.message_view = false;
        break;

      case DocumentsTypes.LIST_DOCUMENT:
        draft.documents = docs;
        break;

      case DocumentsTypes.UPDATE_DOCUMENT_REQUEST:
        draft.request.update_document = {
          ...INITIAL_STATE.request.update_document,
          loading: true,
        };
        break;

      case DocumentsTypes.UPDATE_DOCUMENT_SUCCESS:
        const documentIndex = state.documents.findIndex(
          (singleDocument) => singleDocument.id === document.id,
        );

        draft.documents[documentIndex] = {
          ...state.documents[documentIndex],
          description: document.description,
          document_type_id: document.document_type_id,
          expirationDate: document.expiration_date,
        };

        draft.request.update_document = {
          ...INITIAL_STATE.request.update_document,
          loaded: true,
        };
        break;

      case DocumentsTypes.UPDATE_DOCUMENT_FAILURE:
        draft.request.update_document = {
          ...INITIAL_STATE.request.update_document,
          error: true,
        };
        break;

      case DocumentsTypes.CURRENT_COMPANY:
        draft.documents_list.current_cnpj = currentCompany;
        draft.documents_list.company = company;

        break;

      case DocumentsTypes.AUTHENTICATE_DOCUMENT_REQUEST:
        draft.request.authenticate_document = {
          ...INITIAL_STATE.request.authenticate_document,
          loading: true,
        };

        break;

      case DocumentsTypes.AUTHENTICATE_DOCUMENT_SUCCESS:
        draft.request.authenticate_document = {
          ...INITIAL_STATE.request.authenticate_document,
          loaded: true,
        };

        const docIndex = state.documents.findIndex(
          (singleDocument) => singleDocument.id === document.id,
        );

        draft.documents[docIndex] = {
          ...state.documents[docIndex],
          authenticationStatus: 'pendente',
        };

        break;

      case DocumentsTypes.AUTHENTICATE_DOCUMENT_FAILURE:
        draft.request.authenticate_document = {
          ...INITIAL_STATE.request.authenticate_document,
          error: true,
        };

        break;

      case DocumentsTypes.SET_AUTHENTICATE_DOCUMENT_INITIAL_STATE:
        draft.request.authenticate_document = INITIAL_STATE.request.authenticate_document;

        break;

      default:
        break;
    }
  });
};

export default reducer;
